export default "__VITE_ASSET__VtMwlo3I__"